import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { HeaderMobile } from './HeaderMobile'
import { useIsMobile } from '@/hooks/useIsMobile'

export function AppLayout() {
  const isMobile = useIsMobile()

  // Mobile: no sidebar, no page padding — only the tasks page is designed
  // for mobile, and it manages its own toolbar/spacing edge-to-edge.
  if (isMobile) {
    return (
      <div className="flex h-dvh flex-col overflow-hidden">
        <HeaderMobile />
        <main className="flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </main>
      </div>
    )
  }

  return (
    <div className="flex h-dvh">
      <Sidebar />
      <main className="flex-1 overflow-y-auto transition-all duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none">
        <div className="w-full p-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
